<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0 d-md-flex flex-column">
                <div class="col-12 col-md-12 pl-0 pr-0 pr-md-3 d-flex flex-row">
                    <div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mr-3">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 filter-title cursor-pointer" data-toggle="collapse" data-target="#filterReport"
                            @click="toggleFilter" :class="tfilter == true ? 'active' : ''">
                            <div class="col-6 pl-0 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-10"><span class="mr-2"><i class="fas fa-filter"></i></span>Filter</div>
                            </div>
                        </div>
                        <div id="filterReport" class="collapse">
                            <div class="col-12 pb-3 pl-2 pr-2 font-size-10 bg-white">
                                <div class="col-12 pl-0 pr-0 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Pilih Jenis Laporan</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <!-- <select class="form-control form-control-sm font-size-9 box-purple text-gray rounded-cus"
                                            v-model="tipe.value">
                                            <option v-for="type in dateType" :key="type.value" :value="type.value">{{ type.name }}</option>
                                        </select> -->

                                        <v-select v-model="tipe.value" :options="dateType" label="name" :reduce="el => el.value"
                                            class="font-size-9 w-100">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-12 pt-2 pl-0 pr-0 d-flex" v-if="tipe.value == 1">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Tanggal</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <div class="col-6 pl-0 pr-2">
                                            <datetime input-id="tanggalAwal" :max-datetime="maxDate"
                                                :min-datetime="new Date('2025-01-24').toISOString()" class="theme-purple"
                                                input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                placeholder="Dari Tanggal" v-model="tanggalAwal"></datetime>
                                        </div>
                                        <div class="col-6 pl-0 pr-0">
                                            <datetime input-id="tanggalAkhir" :max-datetime="today" :min-datetime="minDate" class="theme-purple"
                                                input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                placeholder="Sampai Tanggal" v-model="tanggalAkhir"></datetime>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Kode Transaksi</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <input v-model="kode.value"
                                            class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple" type="text"
                                            placeholder="Kode Transaksi">
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Nama Pembeli</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <input v-model="name.value"
                                            class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple" type="text"
                                            placeholder="Nama Pembeli">
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">GS Pembeli</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <input v-model="mid.value"
                                            class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple" type="text"
                                            placeholder="GS Pembeli Ex: GS111111">
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex flex-wrap">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Kode Produk</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <v-select v-model="product.value" :options="dataProduct" label="product_code" title="Pilih Produk"
                                            class="font-size-9 w-100" :reduce="el => el.product_code">
                                            <template v-slot:no-options>
                                                Saat ini tidak ada Produk tersedia
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                {{ option.product_code }} - {{ option.product_name }}
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                {{ option.product_code }} - {{ option.product_name }}
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-5 d-lg-none"></div>
                                    <div class="col-12 col-md-7 col-lg-4 d-flex pl-0 pl-lg-3 pr-0 pr-lg-3 pt-3 pt-lg-0">
                                        <div class="col-6 pl-0 pr-2 pr-md-3">
                                            <button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus" @click="reset"><span
                                                    class="font-size-9">Reset</span></button>
                                        </div>
                                        <div class="col-6 pl-0 pr-0 pr-md-2 pr-lg-3">
                                            <button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus" @click="cari"><span
                                                    class="font-size-9">Cari</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column flex-md-row flex-md-wrap pr-3">
                    <div class="col-12 col-md-6 col-lg-4 pl-0 pr-0 pr-md-3 pt-3">
                        <div class="col-12 pl-0 pr-0 rounded-cus bg-white overflow-hidden">
                            <div class="col-12 pt-2 pb-2 font-size-12 color-white text-center d-flex justify-content-between bg-blue">
                                <div class="col-12 d-flex justify-content-center">Penjualan</div>
                            </div>
                            <div class="col-12 text-center py-2">
                                <div class="pt-1 font-size-15 font-weight-bold" :class="dataSummary.totalSales > 0 ? 'color-green' : ''">{{
                                    dataSummary.totalSales | toRupiah }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 pl-0 pr-0 pr-lg-3 pt-3">
                        <div class="col-12 pl-0 pr-0 rounded-cus bg-white overflow-hidden">
                            <div class="col-12 pt-2 pb-2 font-size-12 color-white text-center d-flex justify-content-between bg-blue">
                                <div class="col-12 d-flex justify-content-center">Harga Pokok Penjualan</div>
                            </div>
                            <div class="col-12 text-center py-2">
                                <div class="pt-1 font-size-15 font-weight-bold" :class="dataSummary.totalSalesBase > 0 ? 'color-red' : ''">
                                    {{
                                        dataSummary.totalSalesBase | toRupiah }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-lg-4 pr-0 pl-0 pt-3">
                        <div class="col-12 pl-0 pr-0 rounded-cus bg-white overflow-hidden">
                            <div class="col-12 pt-2 pb-2 font-size-12 color-white text-center d-flex justify-content-between bg-blue">
                                <div class="col-12 d-flex justify-content-center">Keuntungan</div>
                            </div>
                            <div class="col-12 text-center py-2">
                                <div class="pt-1 font-size-15 font-weight-bold"
                                    :class="dataSummary.totalSalesDiff > 0 ? 'color-green' : dataSummary.totalSalesDiff < 0 ? 'color-red' : ''">
                                    {{ dataSummary.totalSalesDiff | toRupiah }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex pl-0 flex-column flex-md-row">
                    <div class="col-12 col-md-8  pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mt-3 pb-1">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 d-flex">
                            <div class="col-8 col-md-6 pl-0 pb-1 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-sm-11">Laporan Penjualan (New)</div>
                            </div>
                        </div>
                        <div class="col-12 pl-0 pr-0 overflow-auto">
                            <div class="col-12 mt-3 pl-2 pr-2 pb-3 d-flex font-size-10">
                                <div class="col-6 col-md-4 col-lg-2 pl-0">Tanggal</div>
                                <div class="col-6 col-md-3 col-lg-2 pl-0">Kode Transaksi</div>
                                <div class="col-4 col-md-2 col-lg-2 pl-0">GS ID</div>
                                <div class="col-4 col-md-4 col-lg-2 pl-0">Nama</div>
                                <div class="col-3 col-md-2 col-lg-1 pl-0">Kode Produk</div>
                                <div class="col-2 col-md-1 col-lg-1 pl-0 text-center">Jumlah</div>
                                <div class="col-4 col-md-2 col-lg-2 pl-0 text-right">Harga Jual</div>
                                <div class="col-4 col-md-2 col-lg-2 pl-0 text-right">Harga Pokok Penjualan</div>
                            </div>
                            <div class="col-12 pl-2 pr-2 d-flex">
                                <div class="col-12 border-bottom d-none d-lg-block"></div>
                                <div class="col-2 border-bottom d-none d-lg-block"></div>
                            </div>
                            <div v-show="dataSalesReport.length == 0">
                                <div class="col-12 pt-3 pl-2 pr-2" v-for="(index) in 5" :key="index">
                                    <vcl :width='300' :height='15' class="border-bottom">
                                        <rect x="1" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="45" y="2" rx="2" ry="2" width="20" height="7" />
                                        <rect x="70" y="2" rx="2" ry="2" width="50" height="7" />
                                        <rect x="125" y="2" rx="2" ry="2" width="30" height="7" />
                                        <rect x="175" y="2" rx="2" ry="2" width="20" height="7" />
                                        <rect x="210" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="260" y="2" rx="2" ry="2" width="40" height="7" />
                                        <!-- <rect x="1" y="25" rx="2" ry="2" width="28" height="7" />
                                        <rect x="1" y="35" rx="2" ry="2" width="35" height="7" />
                                        <rect x="100" y="18" rx="2" ry="2" width="7" height="7" />
                                        <rect x="110" y="18" rx="2" ry="2" width="28" height="7" />
                                        <rect x="230" y="18" rx="2" ry="2" width="35" height="7" />
                                        <rect x="284" y="19" rx="2" ry="2" width="9" height="9" />
                                        <rect x="284" y="3" rx="2" ry="2" width="9" height="9" /> -->
                                    </vcl>
                                </div>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-if="dataSalesReport == 'error'">
                                <div class="col-12 pt-3 pb-3 text-center">
                                    <div class="col-6 col-md-4 ml-auto mr-auto">
                                        <img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
                                    </div>
                                    <div class="font-size-11 pt-1">Data tidak tersedia!</div>
                                </div>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-else>
                                <div class="col-12 pt-3 pl-2 pr-2 pb-3 d-flex font-size-10"
                                    v-for="(value, index) in dataSalesReport" :key="index">
                                    <div class="col-6 col-md-4 col-lg-2 pl-0">{{ value.trx_datetime | toTanggal }}</div>
                                    <div class="col-6 col-md-3 col-lg-2 pl-0">{{ value.trx_code }}</div>
                                    <div class="col-4 col-md-2 col-lg-2 pl-0">{{ value.trx_buyer_sponsor_network_mid }}</div>
                                    <div class="col-4 col-md-4 col-lg-2 pl-0">{{ value.trx_buyer_name }}</div>
                                    <div class="col-3 col-md-2 col-lg-1 pl-0">{{ value.product_code }}</div>
                                    <div class="col-2 col-md-1 col-lg-1 pl-0 text-center">{{ value.trx_detail_quantity }}</div>
                                    <div class="col-4 col-md-2 col-lg-2 pl-0 text-right">{{ value.total_product_price | toRupiah }}</div>
                                    <div class="col-4 col-md-2 col-lg-2 pl-0 text-right">{{ value.total_product_price_original | toRupiah }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pl-2 pr-2">
                            <div class="col-12 border-bottom"></div>
                        </div>
                        <div class="col-12 pt-3 pl-2 pr-2 text-center">
                            <i-pagination :limit='limit' @changeLimit="changeLimit($event)" :pagination='pagination' @gotoPage="gotoPage($event)"
                                @refresh="refresh($event)"></i-pagination>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-md-4 pl-0 pl-md-3 pr-0 pt-3 pt-md-0 mt-md-3">
                        <div class="col-12 bg-white rounded-cus cus-box-shadow" v-if="productSelling == 'error'">
                            <div class="col-12 pt-3 pl-2 pr-2 d-flex">
                                <div class="col-12 pl-0 mt-auto mb-auto">Produk Terjual</div>
                            </div>
                            <div class="col-12 pb-2 pl-2 pr-2 d-flex" v-if="rangeLaporan == ''">
                                <div class="col-12 pl-0 mt-auto mb-auto"></div>
                            </div>
                            <div class="col-12 pb-2 pl-2 pr-2 d-flex" v-else>
                                <div class="col-12 pl-0 mt-auto mb-auto">{{ rangeLaporan }}</div>
                            </div>
                            <div class="col-12 pt-3 pb-3 text-center">
                                <div class="col-6 ml-auto mr-auto">
                                    <img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
                                </div>
                                <div class="font-size-11 pt-1">Data tidak tersedia!</div>
                            </div>
                        </div>
                        <div class="col-12 bg-white rounded-cus cus-box-shadow" v-else>
                            <div class="col-12 pt-3 pl-2 pr-2 d-flex">
                                <div class="col-12 pl-0 mt-auto mb-auto">Produk Terjual</div>
                            </div>
                            <div class="col-12 pb-2 pl-2 pr-2 d-flex" v-if="rangeLaporan">
                                <div class="col-12 pl-0 mt-auto mb-auto">{{ rangeLaporan }}</div>
                            </div>
                            <div class="col-12 pb-2 pl-2 pr-2 d-flex" v-else>
                                <div class="col-12 pl-0 mt-auto mb-auto"></div>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-show="buyerChartData.length == 1">
                                <vcl :width='300' :height='230'>
                                    <circle cx="150" cy="110" r="90" />
                                </vcl>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-if="buyerChartData.length > 1">
                                <div class="col-12 pl-2 pr-2">
                                    <r-chart :chartData='buyerChartData'></r-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RChart from '@/components/chart/RChart.vue';
import IPagination from '@/components/IPagination.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
    components: {
        RChart,
        IPagination,
    },
    name: 'Report',
    data() {
        return {
            dateType: [{ value: '', name: 'Summary' }, { value: '1', name: 'Pilih Tanggal' }, { value: '2', name: 'Hari ini' }, { value: '3', name: 'Bulan ini' }, { value: '4', name: 'Tahun ini' },],
            tanggalAwal: "",
            tanggalAkhir: "",
            tfilter: false,
            today: new Date().toISOString(),
            limit: 10,
            tanggal: {
                value: '',
                comparison: 'bet',
                type: 'date',
                field: 'trx_datetime'
            },
            kode: {
                value: '',
                comparison: 'LIKE',
                type: 'string',
                field: 'trx_code'
            },
            tipe: {
                value: '2',
                comparison: '=',
                type: 'numeric',
                field: 'date_type'
            },
            name: {
                value: '',
                comparison: 'LIKE',
                type: 'string',
                field: 'trx_buyer_name'
            },
            mid: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'trx_buyer_sponsor_network_mid'
            },
            product: {
                value: 'Pilih Produk',
                comparison: '=',
                type: 'string',
                field: 'product_code'
            },
            params: {},
            rangeLaporan: '',
            page: 1
        }
    },
    methods: {
        gotoPage(val) {
            this.page = val
            if (this.params) {
                this.getSalesReport({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getSalesReport({ page: this.page, limit: this.limit })
            }
        },
        refresh(val) {
            this.page = val
            if (this.params) {
                this.getSalesReport({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getSalesReport({ page: this.page, limit: this.limit })
            }
        },
        changeLimit(val) {
            this.page = 1
            this.limit = val
            if (this.params) {
                this.getSalesReport({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getSalesReport({ page: this.page, limit: this.limit })
            }
        },
        cari() {
            this.params = []
            this.page = 1
            if (this.tipe.value == 1) {
                if (!this.tanggalAkhir) {
                    this.tanggalAkhir = this.tanggalAwal
                }
                if (this.tanggalAkhir == this.tanggalAwal) {
                    this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
                } else {
                    this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
                }
                if (this.tanggalAwal && this.tanggalAkhir) {
                    this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
                    this.params.push(this.tanggal)
                } else {
                    this.rangeLaporan = ''
                }
            }
            if (this.tipe.value == 2 || this.tipe.value == 3 | this.tipe.value == 4) {
                let date = new Date();
                this.tanggal.value = moment(date).format('YYYY-MM-DD')
                if (this.tipe.value == 2) {
                    this.rangeLaporan = moment(date).format('Do MMMM YYYY')
                }
                if (this.tipe.value == 3) {
                    this.rangeLaporan = moment(date).format('MMMM YYYY')
                }
                if (this.tipe.value == 4) {
                    this.rangeLaporan = 'Tahun ' + moment(date).format('YYYY')
                }
                this.params.push({
                    value: this.tanggal.value,
                    comparison: '=',
                    type: 'date',
                    field: 'trx_datetime'
                })
            }
            if (this.tipe.value) {
                this.params.push(this.tipe)
            }
            if (this.kode.value) {
                this.params.push(this.kode)
            }
            if (this.name.value) {
                this.params.push(this.name)
            }
            if (this.mid.value) {
                this.params.push(this.mid)
            }
            if (this.product.value != 'Pilih Produk') {
                this.params.push(this.product)
            }
            this.getSalesReport({ params: this.params, page: this.page, limit: this.limit })
        },
        reset() {
            this.tipe.value = '2'
            this.kode.value = ''
            this.name.value = ''
            this.mid.value = ''
            this.product.value = 'Pilih Produk'
            this.tanggal.value = ''
            this.rangeLaporan = ''
            this.tanggalAwal = ''
            this.tanggalAkhir = ''
            this.page = 1
            this.params = []
            this.params.push(this.tipe)
            this.params.push(this.product)
            this.getSalesReport({ params: this.params, page: this.page, limit: this.limit })
        },
        toggleFilter() {
            if (!this.tfilter) {
                this.tfilter = true;
            } else {
                this.tfilter = false;
            }
        },
        ...mapActions('reportList', ['getSalesReport', 'getProduct']),
    },
    computed: {
        ...mapState('reportList', ['dataSalesReport', 'productSelling', 'dataProduct', 'dataSummary', 'pagination']),
        ...mapGetters('reportList', ['buyerChartData']),
        ...mapState('auth', ['userData']),
        ...mapGetters('auth', ['isAuth']),

        minDate() {
            var date = new Date().toISOString()
            if (this.tanggalAwal) {
                date = new Date(this.tanggalAwal).toISOString()
            } else {
                date = new Date("2025-01-24").toISOString()
            }
            return date
        },
        maxDate() {
            var date = new Date().toISOString()
            if (this.tanggalAkhir) {
                date = new Date(this.tanggalAkhir).toISOString()
            }
            return date
        }
    },
    created() {
        this.$store.dispatch('setPageTitle', 'Laporan Penjualan (New)');
        this.params = []
        if (this.tipe.value == 1) {
            if (!this.tanggalAkhir) {
                this.tanggalAkhir = this.tanggalAwal
            }
            if (this.tanggalAkhir == this.tanggalAwal) {
                this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
            } else {
                this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
            }
            if (this.tanggalAwal && this.tanggalAkhir) {
                this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
                this.params.push(this.tanggal)
            } else {
                this.rangeLaporan = ''
            }
        }
        if (this.tipe.value == 2 || this.tipe.value == 3 | this.tipe.value == 4) {
            let date = new Date();
            this.tanggal.value = moment(date).format('YYYY-MM-DD')
            this.params.push({
                value: this.tanggal.value,
                comparison: '=',
                type: 'date',
                field: 'trx_datetime'
            })
        }
        if (this.tipe.value) {
            this.params.push(this.tipe)
        }
        this.getSalesReport({ params: this.params, page: this.page, limit: this.limit })
        this.getProduct({ params: [], page: this.page, limit: 1000 })
    }
};
</script>
